import React from 'react';
import styles from '../Footer/Footer.module.css'

const Footer = () => {
  return (  
    <>
    <div>
      <img src="" alt="" />
    </div>
    <div className={styles.footer_container}>
      <div className={styles.footer}>
        <p>
        Grace Mutuku &#169; 2022
        </p>
      </div>
    </div>
    </>
  );
}
 
export default Footer;